<app-header></app-header>
<div class="contenedor_principal">
    <app-menu-alterno></app-menu-alterno>
    <div class="contenidoDivTitulo">
        <div class="div-titulo-seccion">
            <h3>Documentación técnica</h3> <h3 *ngIf="tituloTematica != ''"> - {{tituloTematica}}</h3> <img src="/estadisticas-economicas/assets/img/book.png" alt="ícono libro" title="libro"/>
        </div>
        <div class="div-linea-titulo"></div>
    </div>
    <div id="accordion" class="ui-accordion     ui-widget ui-helper-reset" role="tablist">
        <cdk-accordion class="accordion">
            <cdk-accordion-item *ngFor="let dato of listaDataAccordion; let index=index; first as isFirst"
                [expanded]="dato.expanded" #accordionItem="cdkAccordionItem" role="button" tabindex="0"
                [attr.id]="'accordion-header-' + index" [attr.aria-expanded]="accordionItem.expanded"
                [attr.aria-controls]="'accordion-body-' + index">
                <div class="accordion-item-header {{accordionItem.expanded ? 'is-active' : 'not-active'}}"
                    (click)="accordionItem.toggle()">
                    {{ dato.titulo }}
                    <mat-icon *ngIf="!accordionItem.expanded" class="mat-icon-add">add</mat-icon>
                    <mat-icon *ngIf="accordionItem.expanded" class="mat-icon-remove">remove</mat-icon>
                </div>
                <div role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
                    [attr.id]="'accordion-body-' + index" [attr.aria-labelledby]="'accordion-header-' + index">
                    <div *ngIf="dato.id === 1">
                        <table class="metadata-tabla">
                            <tbody *ngFor="let detalleSerie of dato.hijo">
                                <tr>
                                    <th>Temática</th>
                                    <td class="td-nombre-serie">{{detalleSerie.categoriaNivel1}}</td>
                                </tr>
                                <tr>
                                    <th>Categoria</th>
                                    <td>{{detalleSerie.categoria}}</td>
                                </tr>    
                                <tr
                                    *ngIf="detalleSerie.desestacionalizacion != null && detalleSerie.desestacionalizacion != ''">
                                    <th>Ajuste Estacional</th>
                                    <td>{{detalleSerie.desestacionalizacion}}</td>
                                </tr>
                                <tr *ngIf="detalleSerie.fuente != null && detalleSerie.fuente != ''">
                                    <th>Fuente</th>
                                    <td>{{detalleSerie.fuente}}</td>
                                </tr>
                                <tr>
                                    <th>Disponibilidad del dato</th>
                                    <td>{{detalleSerie.fechaInicial}} - {{detalleSerie.fechaFinal}}</td>
                                </tr>
                                <tr
                                    *ngIf="detalleSerie.periodoReferencia != null && detalleSerie.periodoReferencia != ''">
                                    <th>Periodo de Referencia</th>
                                    <td>{{detalleSerie.periodoReferencia}}</td>
                                </tr>
                                <tr *ngIf="detalleSerie.fichaTecnica != null && detalleSerie.fichaTecnica.length > 1">
                                    <th>Ficha metodológica</th>
                                    <td>
                                        <div class="div-row-img">
                                            <ng-container
                                                *ngFor="let ficha of detalleSerie.fichaTecnica; let iFicha=index;">
                                                <ng-container
                                                    *ngIf="ficha.split('.').pop()!.toLowerCase() == 'pdf'; then viewPdf; else viewLink ">
                                                </ng-container>
                                                <ng-template #viewLink>
                                                    <div class="div-column-img">
                                                        <a href="{{ficha}}" target="_blank">
                                                            <img id="imgLink-{{iFicha}}"
                                                                src="/estadisticas-economicas/assets/img/link_icon.png"
                                                                style="width: 40px; height: 40px;" alt="ícono enlace" title="enlace"/>
                                                        </a>
                                                    </div>
                                                </ng-template>
                                                <ng-template #viewPdf>
                                                    <div class="div-column-img">
                                                        <a href="{{ficha}}" target="_blank">
                                                            <img id="imgPDF-{{iFicha}}" src="/estadisticas-economicas/assets/img/icono_pdf.svg"
                                                                style="width: 35px; height: 35px;" alt="ícono pdf" title="pdf"/>
                                                        </a>
                                                    </div>
                                                </ng-template>
                                            </ng-container>
                                        </div>

                                    </td>
                                </tr>
                                <tr *ngIf="detalleSerie.notas != null && detalleSerie.notas.length > 1">
                                    <th colspan="2">
                                        Descripción
                                    </th>
                                </tr>
                                <tr *ngIf="detalleSerie.notas != null && detalleSerie.notas.length > 1">
                                    <td colspan="2">
                                        <div class="recuadro-notas" [innerHTML]="detalleSerie.notas"></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="dato.id === 2">
                        <div id="accordion" class="ui-accordion ui-widget ui-helper-reset" role="tablist">
                            <div role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
                                [attr.id]="'accordion-body-' + index"
                                [attr.aria-labelledby]="'accordion-header-' + index">
                                <div role="region" class="div-notas">
                                    <ul class="ul-lista-enlace-guia">
                                        <li *ngFor="let nota of dato.hijo" class="li-lista-enlace-guia">
                                            <span *ngIf="nota.nombreAdjunto.trim() == ''" [innerHTML]="nota.descripcion"
                                                class="p-descripcion"></span>
                                            <a *ngIf="nota.nombreAdjunto.trim() != ''"
                                                (click)="abrirEnlace(nota.nombreAdjunto)" class="a-link-download-file">
                                                {{nota.descripcion}} </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="dato.id === 3">
                        <div id="accordion" class="ui-accordion ui-widget ui-helper-reset" role="tablist">
                            <div role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
                                [attr.id]="'accordion-body-' + index"
                                [attr.aria-labelledby]="'accordion-header-' + index">
                                <div role="region" class="div-notas">
                                    <ul class="ul-lista-enlace-guia">
                                        <div *ngFor="let nota of dato.hijo">
                                            <ul [innerHTML]="nota"></ul>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    </div>
</div>